// Indian number to words conversion
const ONES = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
  "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

function twoDigit(n) {
  if (n < 20) return ONES[n];
  return TENS[Math.floor(n / 10)] + (n % 10 ? " " + ONES[n % 10] : "");
}

function chunk(num) {
  if (num === 0) return "";
  if (num < 100) return twoDigit(num);
  return ONES[Math.floor(num / 100)] + " Hundred" + (num % 100 ? " " + twoDigit(num % 100) : "");
}

export function amountToWords(amount) {
  if (amount === 0) return "Rupees Zero Only";
  const rupees = Math.floor(Math.abs(amount));
  const paise = Math.round((Math.abs(amount) - rupees) * 100);

  let words = "";
  if (rupees > 0) {
    const crore = Math.floor(rupees / 10000000);
    const lakh = Math.floor((rupees % 10000000) / 100000);
    const thousand = Math.floor((rupees % 100000) / 1000);
    const hundred = rupees % 1000;

    const parts = [];
    if (crore) parts.push(chunk(crore) + " Crore");
    if (lakh) parts.push(chunk(lakh) + " Lakh");
    if (thousand) parts.push(chunk(thousand) + " Thousand");
    if (hundred) parts.push(chunk(hundred));
    words = "Rupees " + parts.join(" ");
  }

  if (paise > 0) {
    const paiseWords = twoDigit(paise);
    words = words ? words + " and Paise " + paiseWords : "Paise " + paiseWords;
  }

  return words + " Only";
}
